import React,{ useState } from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';
//import {getFromStorage, setInStorage,removeFromStorage} from "../utils/storage";
import {AiOutlineCloseCircle} from 'react-icons/ai';
import '../App.css';

//server endpoint
import {ENDPOINT} from '../utils/Constants.js';


function SignIn(props){
  let isShowing = props.isShowing;
  //let hide = props.hide;
  let {signedIn, userName, role} = props.userInfo;
  let [isLoading, setIsLoading]=useState(false);
  let [signInError, setSignInError]=useState('');
  let [signInEmail,setSignInEmail]=useState('');
  let [signInPassword,setSignInPassword]=useState('');

  function handleChange(newUserInfo){
    newUserInfo.signedIn=true
    props.onChange(newUserInfo);//change signedIn value in the parent variable to true
  }

  function onTextboxChangeSignInEmail(event){
    setSignInEmail(event.target.value)
  }
  function onTextboxChangeSignInPassword(event){
    setSignInPassword(event.target.value)
  }

  function onResponseChangeState(message,email,pwd){
    setSignInError(message);
    setIsLoading(false);
    setSignInEmail(email);
    setSignInPassword(pwd);

  }
  function onCloseBox(){
    props.hide();
    setSignInError('');

  }
  //API call when submit button is pressed
  let onSignIn=()=>{
    setIsLoading(true)
    fetch(ENDPOINT + '/api/account/signin',
    {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
        },
      body: JSON.stringify({
        email: signInEmail,
        password: signInPassword
        })
    })
    .then(res => res.json())
        .then(json => {
            if(json.success){
              //update App state
              handleChange({
                userToken: json.token,
                userName: json.userName,
                userID: json.user_id,
                email: signInEmail,
                role: json.role,
                group: json.group,
                participated: json.participated,
                timeSlot: json.timeSlot});
              onResponseChangeState('','','','')
            }
            else{
              onResponseChangeState(json.message,signInEmail,signInPassword)
            }
        });
    }


  if(isShowing){
    return(
      ReactDOM.createPortal(
        <React.Fragment>

          <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
            <div className="modal-overlay" onClick={onCloseBox}/>
            <div className="modal" >
              <div className="modal-header">
                <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={onCloseBox}>
                  <span aria-hidden="true"><AiOutlineCloseCircle/></span>
                </button>
              </div>
              {isLoading ? //if still loading, show loading screen
              <div className='center'>
              <h2>Signing you in...</h2>
              </div>
              : !signedIn ? //otherwise, if user's not signed, show signin form
              <div className='center'>
                <h1>Sign In Form</h1>
                {/*optionally with an error message, if something went wrong in a previous login*/}
                <p className='error message' style={{display: signInError!=='' ? "block" : "none"}}>{signInError}</p>
                <div className="formContainer">
                  <div className="formInnerContainer">
                    <input type="email" placeholder="your@email.ie" className="textInputField"
                           value={signInEmail}
                           onChange={onTextboxChangeSignInEmail}/>
                     <input type="password" placeholder="password" className="textInputField"
                            value={signInPassword}
                            onChange={onTextboxChangeSignInPassword}/>
                    <button className="blue formButton" type="submit" onClick={onSignIn}>Sign In</button>
                  </div>
                </div>
              </div>
                //if we're signed in, check the user's role
                : role===1 ?
              <div className='center'>
                <h2>Congrats, {userName}! You are a wizard.</h2>
                <p>(...and the sign in also worked)</p>
              </div>
                  :
              <div className='center'>
                <h2>Welcome, {userName}! You are signed in.</h2>

              </div>
                }
            </div>
          </div>
        </React.Fragment>, document.body
      )
    )
  }
  else{
    return null
  }
}

export default SignIn;
